import {
    IEditorLifeCycleService,
    LifeCycleEventsMap,
    LifeCycleType,
} from '@src/slide/application/service/editor-lifecycle/core/interface';
import { EventEmitter } from '@src/slide/infrastructure/module/independent/event-emitter';
import { IEventEmitter } from '@src/slide/infrastructure/module/independent/event-emitter/event-emitter.interface';

/**
 * 对整个编辑器生命周期进行管理
 */
export default class EditorLifeCycleService implements IEditorLifeCycleService {
    private event: IEventEmitter<LifeCycleEventsMap>;

    public constructor() {
        this.event = new EventEmitter();
    }
    /**
     * 触发某个生命周期事件
     * @param evenType
     */
    public emitEvent(evenType: LifeCycleType) {
        this.event.emit(evenType);
    }

    /**
     * 监听某个生命周期事件
     * @param evenType
     * @param callBack
     */
    public onEvent(evenType: LifeCycleType, callBack: () => void) {
        this.event.on(evenType, callBack);
    }
}
